export default __webpack_public_path__ + "assets/events.png";